import SVGIconWrapper from "./SVGIconWrapper"

const IconCaretRight = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 500 500"
        iconClass={`icon--caret-right ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M140.6 500c-8.5 0-15.8-3.1-22-9.3s-9.3-13.5-9.3-22V31.2c0-8.5 3.1-15.8 9.3-22s13.5-9.3 22-9.3 15.8 3.1 22 9.3L381.3 228c6.2 6.2 9.3 13.5 9.3 22s-3.1 15.8-9.3 22L162.6 490.7c-6.2 6.2-13.5 9.3-22 9.3z" />
    </SVGIconWrapper>
)

export default IconCaretRight